import { createFileRoute } from '@tanstack/react-router';
import { HelpPage } from '@/features/Help/HelpPage';

export const Route = createFileRoute('/_student/help')({
  component: HelpPage,
});
